import { AbstractEntityMapper } from '@pf/shared-services';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import {
    WarehouseItemSettingCreate,
    WarehouseItemSettingDto,
    WarehouseItemSettingRead,
    WarehouseItemSettingSearchParams,
} from '../../entities/warehouse-item-setting.dto';
import { WarehouseItemSettingsMetadataMap } from './warehouse-item-setting.mapping-profile';

@Injectable()
export class WarehouseItemSettingMapper extends AbstractEntityMapper<
    WarehouseItemSettingRead,
    WarehouseItemSettingCreate,
    WarehouseItemSettingDto,
    WarehouseItemSettingSearchParams
> {
    constructor() {
        super(
            WarehouseItemSettingDto,
            PlatformWmsMapper,
            WarehouseItemSettingsMetadataMap.symbols
        );
    }
}
